import { sortBy } from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { EMPTY_DATA_DASH } from "../constants";
import { useUserContext } from "../context/user.context";
import { environment } from "../environment";
import { TransactionsTablePagination } from "../shared/Tables/TransactionTableSSP";
import { TransactionsTable } from "../shared/Tables/TransactionsTable";
import { CurrencyUtil } from "../utils/currency.util";
import { DateUtil } from "../utils/date.util";
import { getCurrentEndDate, getTransactionStartDate } from "../utils/filter.utils";
import { addMoreZeroes, threeDigitNum } from "../utils/newPOS.util";
import { PaymentTypeUtil, addAmpersandToString, isWalletOrDefault } from "../utils/paymentType.utils";
import { VendingUtils } from "../utils/vending.util";
import { useAxios } from "./useAxios";

export const useTransactionServerSide = () => {
  const { t } = useTranslation();
  const { axiosInstance } = useAxios();

  const [loadingFlag, setLoadingFlag] = useState(false);
  const [loadingFlagForDetails, setLoadingFlagForDetails] = useState(false);

  const [transactionsDataNewEndpoint, setTransactionsDataNewEndpoint] = useState([]); //NEW BACKEND
  const [transactionsDataNewEndpointDetails, setTransactionsDataNewEndpointDetails] = useState([]); //NEW BACKEND

  //TRANSACTION CARDS
  const [totalNumberOfTransactions, setTotalNumberOfTransactions] = useState(0);
  const [totalNumberOfTransactionsDetails, setTotalNumberOfTransactionsDetails] = useState(0);

  const [totalPrices, setTotalPrices] = useState(0);
  const [averagePrice, setAveragePrice] = useState(0);

  //FILTERS FROM ENV
  const [startDateTransactions, setStartDateTransactions] = useState(getTransactionStartDate());
  const [endDateTransactions, setEndDateTransactions] = useState(getCurrentEndDate());

  const [transactionStatesNewBackend, setTransactionStatesNewBackend] = useState([]); //NEW BACKEND
  const [paymentChannelsNewBackend, setPaymentChannelsNewBackend] = useState([]); //NEW BACKEND
  const [monthsPeriodNewBackend, setMonthsPeriodNewBackend] = useState(["Select Month(s)"]); //NEW BACKEND
  const [transactionsTableData, setTransactionsTableData] = useState([]);
  const [notReady, setNotReady] = useState(false);
  const [notReadyDevice, setNotReadyDevice] = useState(false);
  //const [stringFromFilter, setStringFromFilter] = useState("");

  const [refreshButton, setRefreshButton] = useState(false);
  const [refreshButtonDevice, setRefreshButtonDevice] = useState(false);

  const { merchantId } = useUserContext();

  const renderTransactionTableNewEndpoint = () => {
    return <TransactionsTablePagination transactionsTableData={transactionsTableData} />;
  };

  const renderTransactionPerSingleMachineTable = (machineSerialNumber) => {
    //1. FILTER ONLY SELECTED MACHINE DATA

    addFiltersToUrl([], [], startDateTransactions, endDateTransactions, machineSerialNumber, true);

    const transactionsResponseDataOrdered = sortBy(transactionsDataNewEndpointDetails, (item) => item.creationUtcFormatted).reverse();

    //TRANSFORM/EXTRACT ONLY SOME DATA TO DISPLAY (Dont display all data!!!)

    const transactionsTableData = transactionsResponseDataOrdered.map((transaction) => {
      var date = new Date(transaction.creationUtcFormatted);
      let creationDate = date.toLocaleString();

      return {
        "Operator Id": transaction.operatorId,
        "Device Id": addMoreZeroes(transaction.deviceRef),
        "Invoice Id": "" + (transaction.invoiceId !== null ? transaction.invoiceId : EMPTY_DATA_DASH),
        "Date Created": creationDate,
        Amount: (Math.round(transaction.paymentTrans1amount * 100) / 100.0).toFixed(2),
        "Payment Type": VendingUtils.getPaymentTypeName(transaction.triggerPaymentType, transaction.paymentTrans1paymentSubType),
        //TransactionPaymentSubtype: transaction.paymentTrans1paymentSubType ?? "-",
        "Vending State": VendingUtils.getVendingState(transaction.vendingState),
        "Selection number": threeDigitNum(transaction?.selectionNumber?.toString()) || EMPTY_DATA_DASH,
        "Customer Name": transaction?.username || EMPTY_DATA_DASH,
      };
    });

    //console.log("CORRELATION DATA", { machineSerialNumber, transactionDataForSingleMachine, transactionsTableData })
    return <TransactionsTable transactionsTableData={transactionsTableData} />;
  };

  const calculateTransactionData = (transactionsResponseData) => {
    const transactionsResponseDataOrdered = sortBy(transactionsResponseData, (item) => item.creationUtcFormatted).reverse();

    //console.log("TRANSACTION DATA => ", transactionsResponseData, ", ORDERED => ", transactionsResponseDataOrdered)

    // 1. Total Number of Transactions (sum Transactions)
    /* const totalTransactions = transactionsResponseDataOrdered.length;
    setTotalNumberOfTransactions(totalTransactions); */

    //2. Total Amount Prices
    const totalPrices = transactionsResponseDataOrdered.reduce((total, transaction) => total + transaction.paymentTrans1amount, 0);
    setTotalPrices(totalPrices);

    //3. Average Amount Prices
    const averageAmountPrices = totalPrices / totalNumberOfTransactions || 0;
    setAveragePrice(averageAmountPrices.toFixed(2));

    //4. TRANSACTION TABLE DATA
    const tableData = transactionsResponseDataOrdered.map((transaction) => {
      var date = new Date(transaction.creationUtcFormatted);
      let creationDate = date.toLocaleString();

      //console.log("TRANSACTIONS FOR TABLE DATA => ", transaction.deviceRef, date ,creationDate)

      return {
        "Invoice Id": "" + (transaction.invoiceId !== null ? transaction.invoiceId : EMPTY_DATA_DASH),
        "Date Created": creationDate,
        Amount: (Math.round(transaction.paymentTrans1amount * 100) / 100.0).toFixed(2),
        "Payment Type": VendingUtils.getPaymentTypeName(transaction.triggerPaymentType, transaction.paymentTrans1paymentSubType),
        //TransactionPaymentSubtype: transaction.paymentTrans1paymentSubType ?? "-",
        "Vending State": VendingUtils.getVendingState(transaction.vendingState),
        "Operator Id": transaction.operatorId,
        "Device Id": addMoreZeroes(transaction?.deviceRef?.toString()),
        "Selection number": threeDigitNum(transaction?.selectionNumber?.toString()) || EMPTY_DATA_DASH,
        "Customer Name": transaction.username || EMPTY_DATA_DASH,
      };
    });
    setTransactionsTableData(tableData);

    //console.log("TABLE DATA", { tableData })
  };

  const [stringForQuerying, setStringForQuerying] = useState("&vendingStates=4");
  const [stringForQueryingForDetails, setStringForQueryingForDetails] = useState("");

  const addFiltersToUrl = (selected, selectedPaymentType, startDate1, endDate1, deviceId, ifForDetails) => {
    //STRING FOR STATE
    setStartDateTransactions(startDate1);
    setEndDateTransactions(endDate1);

    const generatedStringForState = selected?.map((state) => `vendingStates=${VendingUtils.getVendingStateReversed(state.value)}`).join("&") || "";

    //STRING FOR PAYMENT TYPE
    const generatedStringForPaymentType = isWalletOrDefault(selectedPaymentType);

    const generatedStringForDeviceId = deviceId ? `deviceRef=${deviceId}` : "";

    const valueForReturn = `${generatedStringForState}${addAmpersandToString(
      generatedStringForState,
      generatedStringForPaymentType
    )}${generatedStringForPaymentType}`;

    const evenBiggerStringForReturn = `${valueForReturn}${addAmpersandToString(
      valueForReturn,
      generatedStringForDeviceId
    )}${generatedStringForDeviceId}`;

    //console.log("addFiltersToUrl", { deviceId, ifForDetails, generatedStringForState, generatedStringForDeviceId, valueForReturn, evenBiggerStringForReturn })

    //setStringForQuerying(deviceId ? evenBiggerStringForReturn : valueForReturn);

    ifForDetails
      ? setStringForQueryingForDetails(evenBiggerStringForReturn)
      : setStringForQuerying(deviceId ? evenBiggerStringForReturn : valueForReturn);
  };


  //USE effects for transaction tables
  useEffect(() => {
    //console.log("stringForQuerying", stringForQuerying)
    if (notReady) {
      getPGWTransactionsNewEndpoint(startDateTransactions, endDateTransactions, 0, 10);
    }
  }, [stringForQuerying]);

  useEffect(() => {
    if (refreshButton) {
      setRefreshButton(false);
      getPGWTransactionsNewEndpoint(startDateTransactions, endDateTransactions, 0, 10);
    }
  }, [refreshButton]);

  //USE effects for transaction tables for specific devices
  useEffect(() => {
    if (notReadyDevice) {
      getPGWTransactionsNewEndpointForDetails(startDateTransactions, endDateTransactions, 0, 10);
    }
  }, [stringForQueryingForDetails]);

  useEffect(() => {
    if (refreshButtonDevice) {
      setRefreshButtonDevice(false);
      getPGWTransactionsNewEndpointForDetails(startDateTransactions, endDateTransactions, 0, 10);
    }
  }, [refreshButtonDevice]);

  const getPGWTransactionsNewEndpoint = (startDate1, endDate1, page, pageSize) => {
    setLoadingFlag(true);
    setTransactionsDataNewEndpoint([])
    setTotalNumberOfTransactions(0)
    //console.log("page and new per page", page, pageSize)

    const offset = page === 0 ? 0 : (page - 1) * pageSize;

    const pageSizeConst = pageSize;
    const startDateConverted = DateUtil.formatDate(new Date(startDate1), "dd.MM.yyyy HH:mm:ss");
    const endDateConverted = DateUtil.formatDate(new Date(endDate1), "dd.MM.yyyy HH:mm:ss");

    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}/${environment.getTransactionsV2}/${merchantId}/${startDateConverted}/${endDateConverted}/${pageSizeConst}/${offset}?${stringForQuerying}`;

    if (merchantId) {
      axiosInstance?.current
        ?.get(url)
        .then((res) => {
          const transactionsResponseData = res?.data?.transactions || [];
          setLoadingFlag(false);

          const transactionsResponseDataOrdered = sortBy(transactionsResponseData, (item) => item.creationUtcFormatted).reverse();

          setTransactionsDataNewEndpoint((transactionsDataNewEndpoint) => [...transactionsDataNewEndpoint, ...transactionsResponseDataOrdered]);

          setTotalNumberOfTransactions(res?.data?.maxCount || 0);

          const uniqueDatesArray = DateUtil.filterUniqueDates(
            transactionsResponseData.map((transaction) => new Date(transaction.creationUtcFormatted))
          );
          const uniqueMonths = DateUtil.getUniqueMonthsYears(uniqueDatesArray, "TRANSACTIONS SEARCH MONTHS PERIOD");
          setMonthsPeriodNewBackend(uniqueMonths);

          const tableData = transactionsResponseData.map((transaction) => {
            var date = new Date(transaction.creationUtcFormatted);
            let creationDate = date.toLocaleString();

            return {
              "Invoice Id": "" + (transaction.invoiceId !== 0 ? transaction.invoiceId : "-"),
              "Date Created": creationDate,
              Amount: (Math.round(transaction.paymentTrans1amount * 100) / 100.0).toFixed(2),
              "Payment Type": VendingUtils.getPaymentTypeName(transaction.triggerPaymentType, transaction.paymentTrans1paymentSubType),
              //TransactionPaymentSubtype: transaction.paymentTrans1paymentSubType ?? "-",
              "Vending State": VendingUtils.getVendingState(transaction.vendingState),
              "Operator Id": transaction.operatorId,
              "Device Id": addMoreZeroes(transaction?.deviceRef?.toString()),
              "Selection number": threeDigitNum(transaction?.selectionNumber?.toString()) || EMPTY_DATA_DASH,
              "Customer Name": transaction.username,
            };
          });

          //GET ALL TRANSACTION STATES
          const currentVendingStates = tableData.map((data) => data["Vending State"]);
          setTransactionStatesNewBackend((prevTransactionState) => [...new Set([...prevTransactionState, ...currentVendingStates])]);

          //GET ALL PAYMENT CHANNELS
          const currentPaymentTypes = tableData.map((data) => data["Payment Type"]);
          setPaymentChannelsNewBackend((prevPaymentChannel) => [...new Set([...prevPaymentChannel, ...currentPaymentTypes])]);

          calculateTransactionData(
            transactionsResponseData.filter((val) => {
              return val.vendingState;
            })
          );
        })
        .catch((err) => {
          setLoadingFlag(false);
          if (err?.response?.status === 500) {
            ShowToastMessage(t("toastr.transactions.transactions") + t("toastr.general.cantShow.error500"));
          } else if (err?.response?.status === 401) {
            ShowToastMessage(t("toastr.transactions.transactions") + t("toastr.general.cantShow.error401"));
          } else if (err?.response?.status === 404) {
            ShowToastMessage(t("toastr.transactions.transactions") + t("toastr.general.cantShow.error404"));
          } else if (err?.response?.status === 204) {
            ShowToastMessage(t("toastr.transactions.transactions") + t("toastr.general.cantShow.error204"));
          }
          console.log("NEW BACKEND TRANSACTIONS BATCH CALL ERROR => ", err);
        });
    } else console.error("Merchant is not available", { merchantId, url })
  };

  const getPGWTransactionsNewEndpointForDetails = (startDate1, endDate1, page, pageSize) => {
    setLoadingFlagForDetails(true);
    setTransactionsDataNewEndpointDetails([])
    setTotalNumberOfTransactionsDetails(0)

    const offset = page === 0 ? 0 : (page - 1) * pageSize;

    const pageSizeConst = pageSize;
    const startDateConverted = DateUtil.formatDate(new Date(startDate1), "dd.MM.yyyy HH:mm:ss");
    const endDateConverted = DateUtil.formatDate(new Date(endDate1), "dd.MM.yyyy HH:mm:ss");

    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}/${environment.getTransactionsV2}/${merchantId}/${startDateConverted}/${endDateConverted}/${pageSizeConst}/${offset}?${stringForQueryingForDetails}`;


    if (merchantId) {
      axiosInstance?.current
        ?.get(url)
        .then((res) => {
          const transactionsResponseData = res?.data?.transactions || [];
          setLoadingFlagForDetails(false);

          const transactionsResponseDataOrdered = sortBy(transactionsResponseData, (item) => item.creationUtcFormatted).reverse();

          setTransactionsDataNewEndpointDetails((transactionsDataNewEndpoint) => [...transactionsDataNewEndpoint, ...transactionsResponseDataOrdered]);

          setTotalNumberOfTransactionsDetails(res?.data?.maxCount || 0);

          calculateTransactionData(
            transactionsResponseData.filter((val) => {
              return val.vendingState;
            })
          );
        })
        .catch((err) => {
          setLoadingFlagForDetails(false);
          if (err?.response?.status === 500) {
            ShowToastMessage(t("toastr.transactions.deviceTransactions") + t("toastr.general.cantShow.error500"));
          } else if (err?.response?.status === 401) {
            ShowToastMessage(t("toastr.transactions.deviceTransactions") + t("toastr.general.cantShow.error401"));
          } else if (err?.response?.status === 404) {
            ShowToastMessage(t("toastr.transactions.deviceTransactions") + t("toastr.general.cantShow.error404"));
          } else if (err?.response?.status === 204) {
            ShowToastMessage(t("toastr.transactions.deviceTransactions") + t("toastr.general.cantShow.error204"));
          }
          console.log("NEW BACKEND TRANSACTIONS BATCH CALL ERROR => ", err);
        });
    } else console.error("Merchant is not available", { merchantId, url })
  };

  const [paymentTypes, setPaymentTypes] = useState([]); //NEW BACKEND

  const getFilterStates = (startDate, endDate) => {
    const startDateConverted = DateUtil.formatDate(new Date(startDate), "dd.MM.yyyy HH:mm:ss");
    const endDateConverted = DateUtil.formatDate(new Date(endDate), "dd.MM.yyyy HH:mm:ss");
    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}/${environment.getTransactionsV2}/${merchantId}/s/${startDateConverted}/e/${endDateConverted}`;

    if (merchantId) {
      axiosInstance?.current
        ?.get(url)
        .then((res) => {
          const transactionStates = res?.data || [];

          const paymentMethods = PaymentTypeUtil.getPaymentTypeName(transactionStates);
          setPaymentTypes(paymentMethods);
        })
        .catch((err) => {
          if (err?.response?.status === 500) {
            ShowToastMessage(t("toastr.transactions.paymentTypes") + t("toastr.general.cantShow.error500"));
          } else if (err?.response?.status === 401) {
            ShowToastMessage(t("toastr.transactions.paymentTypes") + t("toastr.general.cantShow.error401"));
          } else if (err?.response?.status === 404) {
            ShowToastMessage(t("toastr.transactions.paymentTypes") + t("toastr.general.cantShow.error404"));
          } else if (err?.response?.status === 204) {
            ShowToastMessage(t("toastr.transactions.paymentTypes") + t("toastr.general.cantShow.error204"));
          }
          console.log("NEW BACKEND TRANSACTION STATES CALL ERROR => ", err);
        });
    } else console.error("Merchand is not available", { merchantId, url })
  };

  const callPeriodDataFetch = (startDate1, endDate1, page, pageSize) => {
    setTransactionsDataNewEndpoint([]);
    setPaymentChannelsNewBackend([]);
    setPaymentTypes([]);
    getPGWTransactionsNewEndpoint(startDate1, endDate1, page, pageSize);
    getFilterStates(startDate1, endDate1);
  };

  const callPeriodDataFetchDetails = (startDate1, endDate1, page, pageSize) => {
    setTransactionsDataNewEndpointDetails([]);
    setPaymentTypes([]);
    getPGWTransactionsNewEndpointForDetails(startDate1, endDate1, page, pageSize);
    getFilterStates(startDate1, endDate1);
  };

  const ShowToastMessage = (text) =>
    toast(<p className="mx-2 tx-16 d-flex align-items-center mb-0 ">{text}</p>, {
      position: toast.POSITION.TOP_RIGHT,
      hideProgressBar: true,
    });

  return {
    loadingFlag,
    startDateTransactions,
    endDateTransactions,
    setStartDateTransactions,
    setEndDateTransactions,
    transactionsDataNewEndpoint,
    transactionStateCardsData: [
      {
        title: `${t("transactions.cards.totalTransactions")}`,
        subtitle: `${t("transactions.cards.totalTransactionsSub")}`,
        value: CurrencyUtil.formatAsNumber(totalNumberOfTransactions).slice(0, -3),
        type: "number",
      },
      {
        title: `${t("transactions.cards.totalAmount")}`,
        subtitle: `${t("transactions.cards.totalAmountSub")}`,
        value: CurrencyUtil.formatAsCurrency(totalPrices),
        type: "currency",
      },
      {
        title: `${t("transactions.cards.averagePrices")}`,
        subtitle: `${t("transactions.cards.averagePricesSub")}`,
        value: CurrencyUtil.formatAsCurrency(averagePrice),
        type: "currency",
      },
    ],
    totalNumberOfTransactions,
    transactionStatesNewBackend,
    paymentChannelsNewBackend,
    monthsPeriodNewBackend,
    callFilterTransactionServer: (startDateTransactions, endDateTransactions, page, pageSize) =>
      callPeriodDataFetch(startDateTransactions, endDateTransactions, page, pageSize),
    callFilterTransactionServerDetails: (startDateTransactions, endDateTransactions, page, pageSize) =>
      callPeriodDataFetchDetails(startDateTransactions, endDateTransactions, page, pageSize),
    calculateTransactionData,
    transactionsTableData,
    SearchableTransactionsTableNewEndpoint: renderTransactionTableNewEndpoint(),
    SearchableTransactionsPerSingleMachineTable: (machineSerialNumber) => renderTransactionPerSingleMachineTable(machineSerialNumber),
    //SERVER SIDE PAGING NEW VARIABLES
    paymentTypes,
    addFiltersToUrl,
    //setStringForQuerying,
    //setStringFromFilter,
    setNotReady,
    notReady,
    setNotReadyDevice,
    notReadyDevice,
    setRefreshButton,
    refreshButton,
    setRefreshButtonDevice,
    refreshButtonDevice,
    totalNumberOfTransactionsDetails,
    loadingFlagForDetails,
    getFilterStates,
  };
};
